import React from 'react';
import { VisualPickerButtonWrapper } from './VisualPickerButton.styles';
import { MarginProps } from '../../../theme/styledProps';

export interface Props extends React.ComponentPropsWithoutRef<'button'>, MarginProps {}

export const VisualPickerButtonContainer: React.FC<Props> = ({ children, ...rest }) => {
  return (
    <VisualPickerButtonWrapper sizeVariant="medium" {...rest}>
      {children}
    </VisualPickerButtonWrapper>
  );
};
